import { render, staticRenderFns } from "./TempConfigDeptList.vue?vue&type=template&id=7a21fe3a&scoped=true"
import script from "./TempConfigDeptList.vue?vue&type=script&lang=js"
export * from "./TempConfigDeptList.vue?vue&type=script&lang=js"
import style0 from "./TempConfigDeptList.vue?vue&type=style&index=0&id=7a21fe3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a21fe3a",
  null
  
)

export default component.exports